define((require) => {
    "use strict";

    var $            = require("jquery"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/assets/youtube/settings/YouTubeSettingsPropertiesView.tpl"),
        Tooltip      = require("ui/common/Tooltip");

    /**
     * The properties view for size and position information.
     *
     * @class YouTubeSettingsPropertiesView
     * @constructor
     */
    return ImprovedView.extend({

        template: template,

        ui: {
            legend: "[data-target=\"#youtube-settings-properties\"]",
            controls: "#controls",
            loop: "#loop",
            autoplay: "#autoplay",
            autoplayExclamationSign: ".glyphicon-exclamation-sign.autoplay",
            mute: "#mute"
        },

        _changeModel: function(ev) {
            var target = $(ev.target);
            this.model.set(target.attr("id"), target.is(":checked"));
        },

        events: {
            "click #loop": "_changeModel",
            "click #autoplay": "_changeModel",
            "click #controls": "_changeModel",
            "click #mute": "_changeModel"
        },

        onRender: function() {
            this.ui.controls.prop("checked", this.model.get("controls"));
            this.ui.autoplay.prop("checked", this.model.get("autoplay"));
            this.ui.loop.prop("checked", this.model.get("loop"));
            this.ui.mute.prop("checked", this.model.get("mute"));

            Tooltip.add(this.ui.autoplayExclamationSign, {
                delay: {show: 500, hide: 0}
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/youtube/settings/YouTubeSettingsPropertiesView.js